import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var PreviewBg =
/** @class */
function (_super) {
  __extends(PreviewBg, _super);

  function PreviewBg() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PreviewBg.prototype.onClick = function (e) {
    if (this.src) {
      wx.previewImage({
        current: this.src,
        urls: [this.src]
      });
    }

    e.stopPropagation();
  };

  __decorate([Prop({
    type: String
  })], PreviewBg.prototype, "src", void 0);

  PreviewBg = __decorate([Component({
    name: 'PreviewBg'
  })], PreviewBg);
  return PreviewBg;
}(Vue);

export default PreviewBg;